export default __webpack_public_path__ + "static/media/acknowledge.f4b6e4fa.svg";